import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { UpdatesCenterBlock } from './updates-center';

function GroupOfBlocksFactory({ ui, ...rest }) {
    const Component = useMemo(() => {
        switch (ui.variant) {
            case 'updates-center':
                return UpdatesCenterBlock;
        }
    }, [ui]);

    return <Component ui={ui} {...rest} />;
}

export default observer(GroupOfBlocksFactory);
